module.exports = __webpack_public_path__ + "static/img/1.捐血活動2025.bf65407.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/charitable-activities/1.捐血活動2025.jpg
// module id = n17o
// module chunks = 98